import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';

/**
 * @typedef {Object} DetailField
 * @property {string} label
 * @property {import('react').ReactNode} value
 */

/**
 * @param {{
 *   fields: DetailField[],
 *   title?: string,
 *   labelMinWidth?: number,
 * }} props
 */
import ContentCard from "./ContentCard";
export default function DetailPanel({ fields, title, labelMinWidth = 160 }) {
  return (
    <ContentCard
      sx={{ overflow: 'hidden'
      }}>
      
      {title &&
      <>
          <Box sx={{ px: 3, py: 2 }}>
            <Typography sx={{ fontWeight: 600, fontSize: '0.9375rem', color: 'var(--grey-900)' }}>
              {title}
            </Typography>
          </Box>
          <Divider sx={{ borderColor: 'var(--grey-200)' }} />
        </>
      }

      <Box sx={{ px: 3, py: 2, display: 'flex', flexDirection: 'column', gap: '14px' }}>
        {fields.map((field) =>
        <Box key={field.label} sx={{ display: 'flex', gap: 2 }}>
            <Typography
            sx={{ fontSize: '0.8125rem',
              color: 'var(--grey-500)',
              minWidth: labelMinWidth,
              flexShrink: 0
            }}>
            
              {field.label}
            </Typography>
            <Typography component="div" sx={{ fontSize: '0.875rem', color: 'var(--grey-900)', flex: 1 }}>
              {field.value ?? '—'}
            </Typography>
          </Box>
        )}
      </Box>
    </ContentCard>);

}